import {
  GET_FRANCHISE_FAILED,
  GET_FRANCHISE_SUCCESSFULLY,
  GET_USER_DETAIL_SUCCESSFULLY,
  GET_USER_DETAIL_FAILED,
  GET_USER_GROUP_SUCCESSFULLY,
  GET_USER_GROUP_FAILED,
  GET_NOTIFICATION_SUCCESSFULLY,
  GET_NOTIFICATION_FAILED,
  GET_USER_ROLES,
  GET_USER_ROLES_FAILED
} from "../../Action/types";

const INITIAL_STATE = {
  franchise: {},
  userDetail: {},
  userGroup: {},
  notifications: {},
  userRoles: {},
  errors: {}
}
const settings = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case GET_FRANCHISE_SUCCESSFULLY:
    return { ...state, ...INITIAL_STATE, franchise: action.data }
  case GET_FRANCHISE_FAILED:
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case GET_USER_DETAIL_SUCCESSFULLY:
    return { ...state, ...INITIAL_STATE, userDetail: action.data }
  case GET_USER_DETAIL_FAILED:
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case GET_USER_GROUP_SUCCESSFULLY:
    return { ...state, ...INITIAL_STATE, userGroup: action.data }
  case GET_USER_GROUP_FAILED:
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case GET_NOTIFICATION_SUCCESSFULLY:
    return { ...state, ...INITIAL_STATE, notifications: action.data }
  case GET_NOTIFICATION_FAILED:
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case GET_USER_ROLES:
    return { ...state, ...INITIAL_STATE, userRoles: action.data }
  case GET_USER_ROLES_FAILED:
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default settings;